<template>
  <component :is="tag" v-bind="binds" class="prizes-2021-prize-item">
    <div class="prizes-2021-prize-item__preview">
      <img
        src="@/assets/img/prizes/2021/preview-bg.png"
        alt=""
        class="prizes-2021-prize-item__bg"
      />
      <img :src="prize.preview" alt="" class="prizes-2021-prize-item__img" />
    </div>
    <div class="prizes-2021-prize-item__name" v-html="prize.name"></div>
  </component>
</template>

<script>
export default {
  name: "Prizes2021PrizeItem",
  props: {
    /** @type {<{name: string, preview: string, href?: string}>} */
    prize: {
      type: Object,
      required: true
    }
  },
  computed: {
    tag() {
      return this.prize.href ? "a" : "div";
    },
    binds() {
      return this.prize.href
        ? { href: this.prize.href, target: "_blank", rel: "noopener" }
        : null;
    }
  }
};
</script>

<style lang="scss">
.prizes-2021-prize-item {
  text-align: center;
  width: 270px;
  padding-top: 25px;

  &__preview {
    margin-bottom: 15px;
    width: 100%;
    height: 215px;
    position: relative;
  }

  &__img,
  &__bg {
    position: absolute;
    pointer-events: none;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &__bg {
    top: calc(50% - 25px);
  }

  &__name {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
    color: #fff;
  }
}
</style>
